var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('media-manager',{attrs:{"title":'Public',"containers":[_vm.publicContainer],"defaultContainer":_vm.publicContainer.name}})}
var staticRenderFns = []

export { render, staticRenderFns }